import Constants from 'client/util/Constants';
import Util from 'client/util/Util';

const apiBase = 'https://api-iam.intercom.io';

const embedIds = {
  [Constants.environments.local]: 'szei9w0a',
  [Constants.environments.staging]: 'szei9w0a',
  [Constants.environments.production]: 'wgmb0rm8',

};

const urls = {
  [Constants.environments.local]: 'https://widget.intercom.io/widget/szei9w0a',
  [Constants.environments.staging]: 'https://thirdparty.jumpcloud.com/js/intercom-support-stg.min.js',
  [Constants.environments.production]: 'https://thirdparty.jumpcloud.com/js/intercom-support-prd.min.js', // currently same url per agreement with CS.
};

export function intercomLoad(attributes) {
  const { Intercom } = window;
  const {
    email, orgId, hasSupport, signupDate, supportLevel,
  } = attributes;
  const embedId = embedIds[Util.getEnvironment()] || embedIds[[Constants.environments.production]];
  Intercom('boot', {
    api_base: apiBase,
    app_id: embedId,
    hide_default_launcher: true,
    email,
    orgId,
    signup_date: signupDate,
    has_support: hasSupport,
    support_level: supportLevel,
  });
}

export function intercomHide() {
  const { Intercom } = window;
  Intercom('hide');
}

export function intercomShow() {
  const { Intercom } = window;
  Intercom('show');
  Intercom('update');
}

export function intercomSetCloseCallback(callback) {
  const { Intercom } = window;
  Intercom('onHide', callback);
}

export function intercomSetShowCallback(callback) {
  const { Intercom } = window;
  Intercom('onShow', callback);
}

export function intercomSetMessageUpdateCallback(callback) {
  const { Intercom } = window;
  Intercom('onUnreadCountChange', callback);
}

export function intercomScript(callback) {
  // Provided by Intercom via our intercom admin console.
  /* eslint-disable */
  const w = window;
  const ic = w.Intercom;
  const url = urls[Util.getEnvironment()] || 'prd';

  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };

    w.Intercom = i;
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = url;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      s.onload = callback;
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}
